import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_PIN_INFOMATION_DATA = "paginationPinInfomationData";
export const LIST_PIN_INFOMATION_DATA = "listPinInfomationData";
export const GET_PIN_INFOMATION_DATA = "getPinInfomationData";
export const POST_PIN_INFOMATION_DATA = "postPinInfomationData";
export const PUT_PIN_INFOMATION_DATA = "putPinInfomationData";
export const PUT_PIN_INFOMATION_STATUS_DATA = "putPinInfomationStatusData";
export const DELETE_PIN_INFOMATION_DATA = "deletePinInfomationData";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";
export const SET_STATE_PRAM_PIN_INFOMATION = "setStarePramPinInfomation";


export default {
  state: {
    path: "pin_infomation",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: "",
      data_pram:''
    }
  },
  getters: {},
  actions: {
    [PAGINATION_PIN_INFOMATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_PIN_INFOMATION_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_PIN_INFOMATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [POST_PIN_INFOMATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [PUT_PIN_INFOMATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [PUT_PIN_INFOMATION_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_PIN_INFOMATION_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_STATE_PRAM_PIN_INFOMATION](state, payload) {
      state.data_pram = payload;
    },
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
